import {connect} from 'pwa-helpers';
import {LitElement, html} from 'lit';
import {navigator, router} from 'lit-element-router';
import {customElement} from 'lit/decorators/custom-element.js';
import {msg} from '@lit/localize';
import store from '../../store';
import style from '../../../../scss/artworks.scss';
import {
	createArtwork
} from '../../slices/artworkSlice';
import {
	selectProfileDefaultLanguage,
	selectCurrentProfileId,
	selectLanguage,
	selectShowArtworksFilter,
} from '../../selectors';
import search from '../../icons/search';
import plus from '../../icons/plus';

import formPageStyle from '../../../../scss/formPage.scss';
import {setShowArtworksFilter} from '../../slices/statusSlice';
import {isPermitted} from '../../util/isPermitted';

@customElement('arc-artworks')
export class Artworks extends connect(store)(navigator(LitElement)) {
	static styles = [formPageStyle, style];

	static properties = {
		materials: {type: Array},
	};

	constructor() {
		super();
		this.currentLanguage = 'en';
		this.artworks = [];
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.status = state.status;
		this.lang = selectLanguage(state);
		this.profileId = selectCurrentProfileId(state);
		this.permittedToEdit = isPermitted(['artwork/edit'], this.profileId, state);

		this.currentLanguage = selectProfileDefaultLanguage(state);

		this.profileId = selectCurrentProfileId(state);
	}

	connectedCallback() {
		super.connectedCallback();
	}

	disconnectedCallback() {
		super.disconnectedCallback();
	}

	handleAddArtwork() {
		store.dispatch(createArtwork({profileId: this.profileId}));
	}
	toggleFilters() {
		store.dispatch(setShowArtworksFilter(
				{showArtworksFilter: !selectShowArtworksFilter(this.state)}
		));
	}

	render() {
		const state = store.getState();

		// console.log('artworksList', this.materials);
		return html`
			<div class="formPage artworks">
				<arc-toolbar class="toolbar">
					<div slot="left">
						<arc-breadcrumbs>
							<arc-routerlink route="artworks">${msg('Artworks')}</arc-routerlink>
						</arc-breadcrumbs>
						<arc-content-language-switch></arc-content-language-switch>
					</div>
					<div slot="right">
						<arc-button
							title="${selectShowArtworksFilter(this.state) ? msg('Hide Filters') : msg('Show Filters')}"
							type="secondary"
							.additionalInfo="${false}"
							.showIcon=${true}
							.showLabel=${true}
							@click="${this.toggleFilters}"
						>${search}</arc-button>
						<arc-button
							title="${msg('Add Artwork')}"
							type="primary"
							.additionalInfo="${false}"
							showLabel=${true}
							showIcon=${true}
							iconColor="ok"
							class="saveProfileButton"
							?disabled="${!this.permittedToEdit}"
							@click=${this.handleAddArtwork}
						>${plus}</arc-button>
					</div>
				</arc-toolbar>

				<arc-artwork-list class="artworkList" .selectMultiple=${true} .noFilters=${false}></arc-artwork-list>
			</div>
		`;
	}
}
